import type { AppDefinition } from '../../types/apps';

export const DOCS_EVENTS = {
  CREATE_DOC: 'DOCS_CREATE',
  DELETE_DOC: 'DOCS_DELETE',
  UPDATE_DOC: 'DOCS_UPDATE',
  OPEN_DOC: 'DOCS_OPEN',
  TOGGLE_DARK_MODE: 'DOCS_TOGGLE_DARK_MODE',
} as const;

export const DocsAppDefinition: AppDefinition = {
  appId: 'docs',
  name: 'Docs',
  version: '1.0.0',
  description: 'Create and manage documents',
  icon: {
    type: 'image',
    imagePath: '/icons/docsApp.svg',
    metadata: {
      source: 'app',
      appId: 'docs',
      isAppIcon: true
    }
  },
  events: {},
  entityTypes: ['Document'],
  searchableSkeletonFields: {
    Document: [], // name-only — body content too large for sync extraction
    Doc:      [], // name-only — body content too large for sync extraction
  },
  component: 'DocsApp',
  requiresProps: false,
  requiresEntity: true,
  isCore: true,
  // Entity icons managed by this app
  entityIcons: {
    'Doc': {
      type: 'svg',
      svgPath: '/icons/riverAppDocSmall.svg',
      metadata: {
        source: 'app',
        appId: 'docs',
        entityType: 'Doc',
        isAppIcon: false
      }
    },
    'Document': {
      type: 'svg',
      svgPath: '/icons/riverAppDocSmall.svg',
      metadata: {
        source: 'app',
        appId: 'docs',
        entityType: 'Document',
        isAppIcon: false
      }
    }
  }
};